import { IDefineCommand, IQuery } from 'core-ts-types';
import * as _4 from 'lodash4';
import { ICampusesDatasource } from '../../sections/datasources/campuses_datasource';
import { Campus } from '../../sections/builders/campus_builder';

export type ILoadCampusListCommand = () => ng.IPromise<IQuery[]>;

angular
  .module('capability-ng-scheduler')
  .service(
    'loadCampusListCommand',
    function loadCampusListDefinition(
      $http: ng.IHttpService,
      defineCommandORM: IDefineCommand,
      ngCampusesDatasource: ICampusesDatasource
    ) {
      return defineCommandORM('loadCampusListCommand', (deferred) =>
        $http
          .get(`/inst/campus/`)
          .then((response) => {
            ngCampusesDatasource.clear().write(response.data as unknown as Record<string, Campus>);
            deferred.resolve();
          })
          .catch(deferred.resolve)
      );
    }
  );



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-scheduler/src/views/unscheduled_sections/commands/load_campus_list_command.ts